export default "<div class=\"content-page-header\"></div>\n<section class=\"content-page-body\">\n  <h1>قريباً</h1>\n</section>\n";